import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation, Scrollbar } from "swiper/modules";
import clsx from "clsx";
import { ICategoryOption, IOption } from "../../../types/customizer";
import { useResizeDetector } from "react-resize-detector";
import ArrowLeft from '../../../../assets/images/left-arrow.png';
import ArrowRight from '../../../../assets/images/right-arrow.png';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/mousewheel";
import './kaySizeFilter.scss';

type IKaySizeFilterProps = {
  options: IOption[];
  size: number;
  onChange: (value: number) => void;
  isSizeChanged: boolean;
  setIsSizeChanged: (value: boolean) => void;
}

const KaySizeFilter = ({ options, size: _size, onChange, isSizeChanged: _isSizeChanged, setIsSizeChanged }: IKaySizeFilterProps) => {
  const [swiper, setSwiper] = useState<any>(null);
  const { width, ref } = useResizeDetector();
  const widthNudgeDoneRef = useRef(false);
  const [activeIndex, setActiveIndex] = useState(() =>
    Math.max(0, options.findIndex(item => item.selected)),
  );

  useEffect(() => {
    setActiveIndex(Math.max(0, options.findIndex(item => item.selected)));
  }, [options]);

  useEffect(() => {
    swiper?.slideTo(activeIndex, 0);
  }, [activeIndex, swiper, options.length]);

  useEffect(() => {
    if (!width || widthNudgeDoneRef.current) return;
    const el = ref.current;
    if (!el) return;
    widthNudgeDoneRef.current = true;
    const w = width;
    el.style.width = `${w + 1}px`;
    const t = globalThis.setTimeout(() => {
      el.style.width = `${w}px`;
    }, 100);
    return () => globalThis.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `ref` from useResizeDetector is not referentially stable; including it retriggers this effect and fights the one-time nudge.
  }, [width]);

  const handleSizeChange = (index: number) => () => {
    if (index !== null && index !== undefined && index !== activeIndex) {
      setActiveIndex(index);
      const option = options[index];
      onChange(Number.parseFloat(option.sku));
    }
    if (index === activeIndex) {
      setIsSizeChanged(true);
    }
  };

  return (
    <div className="kay-size-wrapper tw-overflow-y-auto tw-overflow-x-hidden tw-pb-2">
      <button type="button" className="kay-size-nav kay-size-nav-prev">
        <img src={ArrowLeft} alt="arrow-left" height={13} />
      </button>
      <div className="kay-size-slider-inner tw-w-[calc(100%-100px)]" ref={ref}>
        <Swiper
          className="kay-size-swiper"
          onSwiper={setSwiper}
          slidesPerView="auto"
          slidesPerGroup={6}
          spaceBetween={8}
          initialSlide={activeIndex}
          navigation={{
            prevEl: '.kay-size-nav-prev',
            nextEl: '.kay-size-nav-next',
          }}
          // freeMode={{
          //   enabled: true,
          //   momentum: true,
          //   momentumRatio: 1,
          //   momentumVelocityRatio: 1,
          // }}
          // mousewheel={{
          //   forceToAxis: true,
          //   sensitivity: 1,
          // }}
          modules={[Mousewheel, FreeMode, Scrollbar, Navigation]}
        >
          {options.map((option: IOption | ICategoryOption, index: number) =>
            <SwiperSlide key={index} className={clsx('kay-size-slide tw-cursor-pointer', { 'active-slide': index === activeIndex })} onClick={handleSizeChange(index)}>
              {option.name}
            </SwiperSlide>)
          }
        </Swiper>
      </div>
      <button type="button" className="kay-size-nav kay-size-nav-next">
        <img src={ArrowRight} alt="arrow-right" height={13} />
      </button>
    </div>
  );
};

export default KaySizeFilter;
